import {
  ICreateMetaTagDTO,
  IDeleteMetaTagDTO,
  IGetMetaTagDTO,
  IGetMetaTagResponse,
  IGetMetaTagsDTO,
  IGetMetaTagsResponse,
  IUpdateMetaTagDTO,
  MetaTagsEndpoints,
} from '@/models/metaTags.model';
import { ApiResponse, httpClient } from '@/utils';

class MetaTagsAPI {
  static getMetaTags(data: IGetMetaTagsDTO): ApiResponse<IGetMetaTagsResponse> {
    return httpClient.get<IGetMetaTagsResponse>(MetaTagsEndpoints.META_TAGS, { params: data });
  }

  static getMetaTag(data: IGetMetaTagDTO): ApiResponse<IGetMetaTagResponse> {
    return httpClient.get<IGetMetaTagResponse>(`${MetaTagsEndpoints.META_TAGS}/${data.id}`);
  }

  static createMetaTag(data: ICreateMetaTagDTO): ApiResponse<IGetMetaTagResponse> {
    return httpClient.post<IGetMetaTagResponse>(MetaTagsEndpoints.META_TAGS, data);
  }

  static updateMetaTag({ id, ...data }: IUpdateMetaTagDTO): ApiResponse<IGetMetaTagResponse> {
    return httpClient.put<IGetMetaTagResponse>(`${MetaTagsEndpoints.META_TAGS}/${id}`, data);
  }

  static deleteMetaTag(data: IDeleteMetaTagDTO): ApiResponse<void> {
    return httpClient.delete<void>(`${MetaTagsEndpoints.META_TAGS}/${data.id}`);
  }
}

export default MetaTagsAPI;
